import React from "react";
import Top from "./Top";
import Bottom from "./Bottom";

function App() {
    return(
        <div className="p-6 sm:p-8 md:p-10 lg:p-12">
            <Top />
            <Bottom />
        </div>
    );
}

export default App;